// extracted by mini-css-extract-plugin
module.exports = {"table":"AssignableProductsList_table__1f0mL","title":"AssignableProductsList_title__M-YQS"};